<template>
  <section class="details my-20">
    <Container>
      <SectionHeader>Details</SectionHeader>
      <div>
        <div v-if="getDetails.description.value">
          <FontAwesomeIcon 
            icon="book" 
            class="float-left mr-4 mb-1 size-8!" 
            :class="{
              'text-[#34281A]/80': !getPrimaryColor,
              [`text-[${getPrimaryColor}]/80`]: getPrimaryColor
            }"
          />
          <p class="text-justify font-light leading-8 tracking-wide text-slate-700">
            {{getDetails.description.value}}
          </p>
        </div>
      </div>
      <div class="mx-auto mt-20 grid max-w-5xl space-y-2">
        <div v-for="(detail, index) in list" :key="index" class="grid grid-cols-2 gap-x-6">
          <div
            class="px-2 py-2 font-light text-slate-700"
            :class="{'bg-[#34281A]/10': index % 2 === 0}"
          >
            {{detail.label}}
          </div>
          <div
            class="p-2 text-right font-light text-slate-700"
            :class="{'bg-[#34281A]/10': index % 2 === 0}"
          >
            {{detail.value}}
          </div>
        </div>
      </div>
    </Container>
  </section>
</template>

<script>
  import { mapGetters } from 'vuex';
  import SectionHeader from '../../components/SectionHeader';
  import Container from '../../components/Container';

  export default {
    name: 'Details',
    components: {
      SectionHeader,
      Container
    },
    computed: {
      ...mapGetters('tour', ['getDetails', 'getPrimaryColor']),
      list () {
        return Object.values(this.getDetails).filter(detail => detail.label !== 'Description') || [];
      }
    }
  };
</script>
